import valueAt from 'lodash/get'
const clientConfig = require('clientconfig')

export function config (path, defaultValue) {
  return valueAt(clientConfig, path) || defaultValue
}

export default require('clientconfig')



// WEBPACK FOOTER //
// /src/config.js